import { createFileRoute, redirect } from '@tanstack/react-router'

import { WorkflowRoute } from '@/app/routes/_app/workflows/workflows'
import { getUserInfo } from '@/features/auth'
import { SignUpConfirmPage } from '@/pages/sign-up-confirm'

export const Route = createFileRoute('/sign-up-confirm')({
  component: RouteComponent,
  loader: async () => {
    try {
      const userInfo = await getUserInfo()
      if (userInfo) return redirect({ to: WorkflowRoute.to })
    } catch {
      // 🏡 stay on sign up confirm page
    }
  },
})

export const SignUpConfirmationRoute = Route

function RouteComponent() {
  return <SignUpConfirmPage />
}
